import { ContinuousPerformanceStageConfig, CPTCustomConfiguration } from "types/testTypes";

const moxxoNoDistractors01: ContinuousPerformanceStageConfig = {
  stageName: "ND_01",
  stageDuration: 140,
  stimulusDuration: 3,
  fastStimulusDuration: 0.6,
  minAllowedDurationPercentage: 0.5,
  responseIgnoreDuration: 0.2,
  targetNonTargetFrequency: 0.25,
  fastTargetNonTargetFrequency: 1,
  targetProbability: 0.42,
  visualDistractorFrequency: 0,
  audioDistractorFrequency: 0,
  audioVisualDistractorFrequency: 0,
  simultanousDistractors: 1,
  fastSequenceCount: 5,
  inhibitionCount: 0,
  vigilanceCount: 0,
  consecutiveStimulusCount: 5,
};

const moxxoVisualDistractorsOnlySingle01: ContinuousPerformanceStageConfig = {
  stageName: "VD_S_01",
  stageDuration: 105,
  stimulusDuration: 3,
  fastStimulusDuration: 0.6,
  minAllowedDurationPercentage: 0.5,
  responseIgnoreDuration: 0.2,
  targetNonTargetFrequency: 0.25,
  fastTargetNonTargetFrequency: 1,
  targetProbability: 0.42,
  visualDistractorFrequency: 0.2,
  audioDistractorFrequency: 0,
  audioVisualDistractorFrequency: 0,
  simultanousDistractors: 1,
  fastSequenceCount: 5,
  inhibitionCount: 0,
  vigilanceCount: 0,
  consecutiveStimulusCount: 5,
};

const moxxoVisualDistractorsOnlyDouble01: ContinuousPerformanceStageConfig = {
  stageName: "VD_D_01",
  stageDuration: 105,
  stimulusDuration: 3,
  fastStimulusDuration: 0.6,
  minAllowedDurationPercentage: 0.5,
  responseIgnoreDuration: 0.2,
  targetNonTargetFrequency: 0.25,
  fastTargetNonTargetFrequency: 1,
  targetProbability: 0.42,
  visualDistractorFrequency: 0.2,
  audioDistractorFrequency: 0,
  audioVisualDistractorFrequency: 0,
  simultanousDistractors: 2,
  fastSequenceCount: 5,
  inhibitionCount: 0,
  vigilanceCount: 0,
  consecutiveStimulusCount: 5,
};

const moxxoAudioDistractorsOnlySingle01: ContinuousPerformanceStageConfig = {
  stageName: "AD_S_01",
  stageDuration: 105,
  stimulusDuration: 3,
  fastStimulusDuration: 0.6,
  minAllowedDurationPercentage: 0.5,
  responseIgnoreDuration: 0.2,
  targetNonTargetFrequency: 0.25,
  fastTargetNonTargetFrequency: 1,
  targetProbability: 0.42,
  visualDistractorFrequency: 0,
  audioDistractorFrequency: 0.2,
  audioVisualDistractorFrequency: 0,
  simultanousDistractors: 1,
  fastSequenceCount: 5,
  inhibitionCount: 0,
  vigilanceCount: 0,
  consecutiveStimulusCount: 5,
};

const moxxoAudioDistractorsOnlyDouble01: ContinuousPerformanceStageConfig = {
  stageName: "AD_D_01",
  stageDuration: 105,
  stimulusDuration: 3,
  fastStimulusDuration: 0.6,
  minAllowedDurationPercentage: 0.5,
  responseIgnoreDuration: 0.2,
  targetNonTargetFrequency: 0.25,
  fastTargetNonTargetFrequency: 1,
  targetProbability: 0.42,
  visualDistractorFrequency: 0,
  audioDistractorFrequency: 0.2,
  audioVisualDistractorFrequency: 0,
  simultanousDistractors: 2,
  fastSequenceCount: 5,
  inhibitionCount: 0,
  vigilanceCount: 0,
  consecutiveStimulusCount: 5,
};

const moxxoAudioVisualDistractorsSingle01: ContinuousPerformanceStageConfig = {
  stageName: "AVD_S_01",
  stageDuration: 105,
  stimulusDuration: 3,
  fastStimulusDuration: 0.6,
  minAllowedDurationPercentage: 0.5,
  responseIgnoreDuration: 0.2,
  targetNonTargetFrequency: 0.25,
  fastTargetNonTargetFrequency: 1,
  targetProbability: 0.42,
  visualDistractorFrequency: 0,
  audioDistractorFrequency: 0,
  audioVisualDistractorFrequency: 0.2,
  simultanousDistractors: 1,
  fastSequenceCount: 5,
  inhibitionCount: 0,
  vigilanceCount: 0,
  consecutiveStimulusCount: 5,
};

const moxxoAudioVisualDistractorsDouble01: ContinuousPerformanceStageConfig = {
  stageName: "AVD_D_01",
  stageDuration: 105,
  stimulusDuration: 3,
  fastStimulusDuration: 0.6,
  minAllowedDurationPercentage: 0.5,
  responseIgnoreDuration: 0.2,
  targetNonTargetFrequency: 0.25,
  fastTargetNonTargetFrequency: 1,
  targetProbability: 0.42,
  visualDistractorFrequency: 0,
  audioDistractorFrequency: 0,
  audioVisualDistractorFrequency: 0.2,
  simultanousDistractors: 2,
  fastSequenceCount: 5,
  inhibitionCount: 0,
  vigilanceCount: 0,
  consecutiveStimulusCount: 5,
};

const moxxoNoDistractors02: ContinuousPerformanceStageConfig = {
  stageName: "ND_01",
  stageDuration: 140,
  stimulusDuration: 3,
  fastStimulusDuration: 0.6,
  minAllowedDurationPercentage: 0.5,
  responseIgnoreDuration: 0.2,
  targetNonTargetFrequency: 0.25,
  fastTargetNonTargetFrequency: 1,
  targetProbability: 0.42,
  visualDistractorFrequency: 0,
  audioDistractorFrequency: 0,
  audioVisualDistractorFrequency: 0,
  simultanousDistractors: 1,
  fastSequenceCount: 5,
  inhibitionCount: 0,
  vigilanceCount: 0,
  consecutiveStimulusCount: 5,
};

const CPTDefaultStages: ContinuousPerformanceStageConfig[] = [
  moxxoNoDistractors01,
  moxxoVisualDistractorsOnlySingle01,
  moxxoVisualDistractorsOnlyDouble01,
  moxxoAudioDistractorsOnlySingle01,
  moxxoAudioDistractorsOnlyDouble01,
  moxxoAudioVisualDistractorsSingle01,
  moxxoAudioVisualDistractorsDouble01,
  moxxoNoDistractors02,
];

const CPTDemoStages: ContinuousPerformanceStageConfig[] = [
  { ...moxxoAudioVisualDistractorsSingle01, stageDuration: 30, fastSequenceCount: 2 },
  { ...moxxoAudioVisualDistractorsDouble01, stageDuration: 30, fastSequenceCount: 2 },
];

const CPTAdultDefaultStages: ContinuousPerformanceStageConfig[] = CPTDefaultStages;

const CPTAdultDemoStages: ContinuousPerformanceStageConfig[] = CPTDemoStages;

export const CPTCustomDefaultConfig: Partial<CPTCustomConfiguration> = {
  stages: CPTDefaultStages,
  isForAdult: false,
  isTriggerClickEnabled: false,
};

export const CPTCustomDemoConfig: Partial<CPTCustomConfiguration> = {
  stages: CPTDemoStages,
  isForAdult: false,
  isTriggerClickEnabled: false,
};

export const CPTAdultCustomDefaultConfig: Partial<CPTCustomConfiguration> = {
  stages: CPTAdultDefaultStages,
  isForAdult: true,
  isTriggerClickEnabled: false,
};

export const CPTAdultCustomDemoConfig: Partial<CPTCustomConfiguration> = {
  stages: CPTAdultDemoStages,
  isForAdult: true,
  isTriggerClickEnabled: false,
};
